import logo from "./logo.svg";
import "./App.css";
import Home from "./Screens/Home";
import "./assets/style.css";
import "./assets/styles/chatScreen.css";
import "./assets/styles/myContracts.css";
import "./assets/styles/notificationMenu.css";
import "./assets/styles/responsive.css";
// import "./assets/styles/myContracts.css";
// import "./assets/styles/notificationMenu.css";
import Header from "./Components/Header";
import JobsCard from "./Components/JobsCard";
import Footer from "./Components/Footer";
import Companies from "./Screens/Companies";
import Craftmen from "./Screens/Craftmen";
import AllJobs from "./Screens/AllJobs";
import Button from "@restart/ui/esm/Button";
import { Provider, useSelector } from "react-redux";
import { PersistGate } from "redux-persist/lib/integration/react";
import { store, persistor } from "./store/index";

import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useHistory,
} from "react-router-dom";
import { useEffect, useState } from "react";
import CraftmenJobs from "./Screens/CraftmenJobs";
import AboutUs from "./Screens/AboutUs";
import ContactUs from "./Screens/ContactUs";
import JobDetailScreen from "./Screens/JobDetailScreen";
import Signin from "./Screens/Signin";
import ProfileStepForm from "./Screens/ProfileStepForm";
import ProfileStudent from "./Screens/ProfileStudent";
import JobPost from "./Screens/JobPost";
import DashboardCompany from "./Screens/DashboardCompany";
import Contract from "./Components/Contract";
import EditProfile from "./Screens/EditProfile";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import ProtectedRouter from "./Components/ProtectedRouter";
import AppliedJobs from "./Screens/AppliedJobs";
import ChangePasswordScreeb from "./Screens/ChangePasswordScreeb";
import Companyfollowers from "./Screens/CompanyFollowers";
import "./assets/styles/newstyle.css";
// import "./assets/styles/chatScreen.css";
import ChatScreen from "./Screens/ChatScreen";
import CraftmanProfile from "./Screens/CraftmanProfile";
import MyContracts from "./Screens/MyContracts";
import CompanyContracts from "./Screens/CompanyContracts";
import CraftmanPublicProfile from "./Screens/CraftmanPublicProfile";
import TermsAndConditions from "./Screens/TermsAndConditions";
import ForgotPassword from "./Screens/ForgotPassword";
import Otp from "./Screens/Otp";
import ResetPassword from "./Screens/ResetPassword";

import firebase, { messaging } from "./firebase";
import { firebaseVapidObject } from "./Config/apiUrl";

function App() {
  const [footerStyle, setfooterStyle] = useState(false);

  // If firebase supported, take out token and send to server
  // useEffect(() => {
  //   const getToken = async () => {
  //     let token = "";
  //     if (firebase.messaging.isSupported()) {
  //       token = await messaging.getToken(firebaseVapidObject);
  //       console.log(token);
  //     }
  //   };

  //   getToken();
  // }, []);

  useEffect(() => {
    const fire = async () => {
      if (firebase?.messaging?.isSupported()) {
        let token = await messaging?.getToken(firebaseVapidObject);
        console.log(token);

        messaging
          .requestPermission()
          .then(() => {
            return messaging?.getToken();
          })
          .then((data) => {
            console.warn("token", {data}, "FMC=> => FCM");
          });
      }
    };

    fire();
  }, []);

  return (
    <>
      <Provider store={store}>
        <PersistGate persistor={persistor}>
          <ToastContainer />
          <Router>
            <Switch>
              {/* Main */}
              <Route exact path="/">
                <Header />
                <Home />
                <Footer footerStyle={footerStyle} />
              </Route>
              {/* Sign up */}
              <Route path="/signin">
                <Header />
                <Signin setfooterStyle={setfooterStyle} />
              </Route>
              {/* Forgot Password */}
              <Route path="/forgot-password">
                <ForgotPassword />
              </Route>
              {/* Otp */}
              <Route path="/otp">
                <Otp />
              </Route>
              {/* ResetPassword */}
              <Route path="/reset-password">
                <ResetPassword />
              </Route>
              {/* Signin */}
              <Route path="/signup">
                <Header />
                <ProfileStepForm setfooterStyle={setfooterStyle} />
              </Route>
              {/* aboutus */}
              <Route path="/aboutus">
                <Header />
                <AboutUs setfooterStyle={setfooterStyle} />
                <Footer footerStyle={footerStyle} />
              </Route>
              {/* contact us */}
              <Route path="/contactUs">
                <Header />
                <ContactUs setfooterStyle={setfooterStyle} />
                <Footer footerStyle={footerStyle} />
              </Route>
              {/* dashboard */}
              <Route path="/dashboard">
                <Header />
                <DashboardCompany setfooterStyle={setfooterStyle} />
                <Footer footerStyle={footerStyle} />
              </Route>
              {/* Companies */}
              <Route path="/Companies">
                <Header />
                <Companies />
                <Footer footerStyle={footerStyle} />
              </Route>

              {/* Craftman */}
              <Route path="/Craftmen">
                <Header />
                <Craftmen />
                <Footer footerStyle={footerStyle} />
              </Route>
              {/* Craftman */}
              <Route path="/terms-and-conditions">
                <Header />
                <TermsAndConditions />
                <Footer footerStyle={footerStyle} />
              </Route>
              {/* Craftman */}
              <Route path="/craftman-profile">
                <Header />
                <CraftmanProfile setfooterStyle={setfooterStyle} />
                <Footer footerStyle={footerStyle} />
              </Route>

              {/* AllJobs */}
              <Route path="/AllJobs">
                <Header />
                <AllJobs setfooterStyle={setfooterStyle} />
                <Footer footerStyle={footerStyle} />
              </Route>

              {/* /job/:id */}
              <Route path="/job/:id">
                <Header />
                <JobDetailScreen setfooterStyle={setfooterStyle} />
                <Footer footerStyle={footerStyle} />
              </Route>
              <Route path="/messages">
                <Header />
                <ChatScreen />
                <Footer footerStyle={footerStyle} />
              </Route>
              {/* My Contracts */}
              <Route path="/my-contracts">
                <Header />
                <MyContracts />
                <Footer footerStyle={footerStyle} />
              </Route>
              {/* Company Contracrs */}
              <Route path="/company-contracts">
                <Header />
                <CompanyContracts />
                <Footer footerStyle={footerStyle} />
              </Route>
              {/* Craftman Public Profile */}
              <Route path="/ctaftman-profile">
                <Header />
                <CraftmanPublicProfile setfooterStyle={setfooterStyle} />
                <Footer footerStyle={footerStyle} />
              </Route>
              {/* All Jobs */}
              {/* <ProtectedRouter
                path="/AllJobs"
                component={
                  <>
                    <Header />
                    <AllJobs setfooterStyle={setfooterStyle} />
                    <Footer footerStyle={footerStyle} />
                  </>
                }
              /> */}

              {/* AllJobs1 */}
              <ProtectedRouter
                path="/AllJobs1"
                component={
                  <>
                    <Header />
                    <CraftmenJobs setfooterStyle={setfooterStyle} />
                    <Footer footerStyle={footerStyle} />
                  </>
                }
              />

              {/* job/:id */}
              {/* <ProtectedRouter
                path="/job/:id"
                component={
                  <>
                    <Header />
                    <JobDetailScreen setfooterStyle={setfooterStyle} />
                    <Footer footerStyle={footerStyle} />
                  </>
                }
              /> */}

              {/* Contract */}
              <ProtectedRouter
                path="/Contract"
                component={
                  <>
                    <Header />
                    <Contract setfooterStyle={setfooterStyle} />
                    <Footer footerStyle={footerStyle} />
                  </>
                }
              />

              {/* JobPost */}
              <ProtectedRouter
                path="/JobPost"
                component={
                  <>
                    <Header />
                    <JobPost setfooterStyle={setfooterStyle} />
                    <Footer footerStyle={footerStyle} />
                  </>
                }
              />

              {/* profile */}
              <ProtectedRouter
                path="/profile"
                component={
                  <>
                    <Header />
                    <ProfileStudent setfooterStyle={setfooterStyle} />
                    <Footer footerStyle={footerStyle} />
                  </>
                }
              />

              {/* editProfile */}
              <ProtectedRouter
                path="/editProfile"
                component={
                  <>
                    <Header />
                    <EditProfile setfooterStyle={setfooterStyle} />
                    <Footer footerStyle={footerStyle} />
                  </>
                }
              />

              {/* appliedJobs */}
              <ProtectedRouter
                path="/appliedJobs"
                component={
                  <>
                    <Header />
                    <AppliedJobs setfooterStyle={setfooterStyle} />
                    <Footer footerStyle={footerStyle} />
                  </>
                }
              />

              {/* appliedJobs */}
              <ProtectedRouter
                path="/changePassword"
                component={
                  <>
                    <Header />
                    <ChangePasswordScreeb setfooterStyle={setfooterStyle} />
                    <Footer footerStyle={footerStyle} />
                  </>
                }
              />
              {/* appliedJobs */}
              <ProtectedRouter
                path="/followers"
                component={
                  <>
                    <Header />
                    <Companyfollowers setfooterStyle={setfooterStyle} />
                    <Footer footerStyle={footerStyle} />
                  </>
                }
              />
            </Switch>
          </Router>
        </PersistGate>
      </Provider>
    </>
  );
}

export default App;
